export default "dist/images/a1110d6c8d16a14c4570411750248399.png";